import React from 'react';
import ButtonOutlinePrimary from '../misc/ButtonOutlinePrimary';
const TabAccount = () => {
  return (
    <div className="flex flex-col">
      <h1 className="font-semibold text-3xl text-font-gray my-1 leading-7">
        Akun
      </h1>
      <p className="text-font-gray capitalize mb-4">Rincian Akun</p>
      <div className="flex flex-col w-8/12 max-w-md">
        <div className="flex py-2 my-1 border-b border-gray-200 text-font-gray capitalize items-center">
          <p className="w-4/12">Nama</p>
          <p className="w-5/12">Stevani</p>
        </div>
        <div className="flex py-2 my-1 border-b border-gray-200 text-font-gray capitalize items-center">
          <p className="w-4/12">Nomor Telepon</p>
          <p className="w-5/12">08123456789</p>
        </div>
        <div className="flex py-2 my-1 border-b border-gray-200 text-font-gray capitalize items-center">
          <p className="w-4/12">Email</p>
          <p className="w-5/12">stevanie@gmail.com</p>
        </div>
        <div className="flex py-2 my-1 border-b border-gray-200 text-font-gray capitalize items-center">
          <p className="w-4/12">Password</p>
          <p className="flex-grow">********</p>
          <ButtonOutlinePrimary addClass="capitalize " text="sm">
            {' '}
            Ganti Password{' '}
          </ButtonOutlinePrimary>
        </div>
      </div>
    </div>
  );
};

export default TabAccount;
